$(document).ready(function($) {
  $(document).scrollTop(1);
         var provincesF = $(".mobile-bypass-zones").attr("Bypass-Zone");
        var mobileEnableBypass = $(".mobile-bypass-zones").attr("data-enable-mobile-bypass");
        var desktopCheck = $(".dsktop-check-jtpl").attr("dsktop-postalCodes");
        var windowsize = $(window).width();

          jQuery.getJSON('/cart.js', function(cart) {
          console.log(cart.attributes)
            var attributes = cart.attributes;
          // if ($(".location-menu").hasClass("addcity")) 
           var cities = getCookie("jtpl-cities");
            var region = getCookie("jtpl-region");
            var postalCodeCurrnt = getCookie("jtpl-postal");
            
          var url = window.location.href;
          //   console.log(region+"===="+attributes.postalRegion+"========="+cities+"=========="+attributes.postalCity)
           
           if (cities == "" && url.indexOf("myshopify.com") == -1 ){            
             $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                async:false,
                dataType: 'json',
                success: function() {
                  console.log("successsssss");
                },
                error: function(XMLHttpRequest, textStatus) {
                 console.log(XMLHttpRequest);
                }
              });
             
            $.ajax({
              url: 'https://ipapi.co/json/?key=6DXobwykfgUZVF9wmnSo3Vrt4ho3gPUCm2gjUj2MoFZIgHring',
              dataType: 'json',
              async:false,
                type: 'GET',
              complete: function(data) {
               var crrnt_city = data.responseJSON.city;
                var crrnt_region = data.responseJSON.region;
                var crrnt_code = data.responseJSON.postal;
              var data = {
              attributes: {
                  postalCode: crrnt_code,
                  postalCity: data.responseJSON.city,
                  postalRegion: data.responseJSON.region,
              }
          };
          if (mobileEnableBypass == 'true' && provincesF.includes(crrnt_region) && windowsize < 768) {
               var data = {
              attributes: {
                  postalCode: crrnt_code,
                  postalCity: "Laval",
                  postalRegion: "New Brunswick",
              }
            };
                 }
             
              var cities = getCookie("jtpl-cities");
              if (cities != "") {
              } else {
              setCookie("jtpl-cities", crrnt_city);
              }
                var region = getCookie("jtpl-region");
              if (region != "") {
              } else {
              setCookie("jtpl-region", crrnt_region);
              } 
              var postalCodeCurrnt = getCookie("jtpl-postal");
              if (postalCodeCurrnt != "") {
              } else {
              setCookie("jtpl-postal", crrnt_code);
              } 
             $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
              contentType: 'application/json',
              async:false,
                type: 'POST',
              data: JSON.stringify(data),
              complete: function(xhr) {

                  console.log(xhr.responseJSON);
                  location.reload();
              setTimeout(function(){
               $(".coll-prices-jtpl span").attr("style","visibility:visible !important;");
                $(".coll-prices-jtpl").removeClass("animated-background");
            },500);               
                  
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });
                                
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });
          }else{
              var cities = getCookie("jtpl-cities");
            var region = getCookie("jtpl-region");
            var postalCodeCurrnt = getCookie("jtpl-postal");
           // console.log(region+"===="+attributes.postalRegion+"========="+cities+"======"+attributes.postalCity);
             if($.trim(region) != $.trim(attributes.postalRegion) || $.trim(cities) != $.trim(attributes.postalCity)){
               //console.log("herereee");
              removeCartAttributes();
            }
            setTimeout(function(){
               $(".coll-prices-jtpl span").attr("style","visibility:visible !important;");
                $(".coll-prices-jtpl").removeClass("animated-background");
            },500);
          }
 });
    $(document).ready(function($) {
    $('.postal-code-form').submit(function(e){
          e.preventDefault();
          var value = $(this).find('.postal-code-input').val();
          // var city_name = $(this).find('.postal-city-input').val();
          // var region = $(this).find('.postal-region-input').val();
          var data = {
              attributes: {
                  postalCode: value,
                //   postalCity: city_name,
                // postalRegion: region,
              }
          };
          $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
              contentType: 'application/json',
              type: 'POST',
              async:false,
                data: JSON.stringify(data),
              complete: function(xhr) {
                
                  console.log(xhr.responseJSON);
                  location.reload();
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });
      });
      
 $('.popupCloseButton').click(function(e){
    var currntPostCode = getCookie("jtpl-postal");
    setCookiePopup("popup-postal-jtpl", "");
     $("body").removeClass("postal-popup-overlay"); 
         $(".hover_background").hide();
      });
      
  $('.postal-code-form-jtpl').submit(function(e){
    e.preventDefault();
    var newPostalCode =  $(this).find("input.postal-code-input").val();
        var data = {
              attributes: {
                  popupPostalCode: newPostalCode,
              }
          };
          $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
              contentType: 'application/json',
              type: 'POST',
              async:false,
                data: JSON.stringify(data),
              complete: function(xhr) {
                 setCookiePopup("popup-postal-jtpl", newPostalCode);
                  console.log(xhr.responseJSON);
                  location.reload();
              setTimeout(function(){
               $(".coll-prices-jtpl span").attr("style","visibility:visible !important;");
                $(".coll-prices-jtpl").removeClass("animated-background");
            },500);
               
                  
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });

      });

      
      $('.change-postal-code').click(function(e){
          e.preventDefault();
        changePostalDetails();
      });
 var handleCancelSearch = '';
document.querySelector('.t4s-site-nav__search .t4s-d-lg-none').addEventListener('click', function() {
   $('#t4s-search-hidden .t4s-mini-search__input').trigger("click");
  document.querySelector('#t4s-search-hidden .t4s-mini-search__input').click();
  
    document.querySelector('#t4s-search-hidden').style.display = 'none';
    
    handleCancelSearch = setInterval(getCancel, 100);
});

function getCancel() {
  if(document.querySelectorAll('.cloud-search-mobile .cloud-search-mobile__cancel').length > 0){
    var cancelButtons = document.querySelectorAll('.cloud-search-mobile .cloud-search-mobile__cancel');
    cancelButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            document.querySelector('.t4s-drawer__close').click();
            document.body.classList.remove('is--opend-drawer', 't4s-lock-scroll');
        });
    });
       var backdropButtons = document.querySelectorAll('.cloud-search-mobile-backdrop');
    backdropButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            document.querySelector('.t4s-drawer__close').click();
            document.body.classList.remove('is--opend-drawer', 't4s-lock-scroll');
        });
    });
    clearInterval(handleCancelSearch);
  }
}

 
      $('.tab_title_block a').click(function(e){
          e.preventDefault();
      var dataTargetVal =   $(this).attr("href");
        $(".tab_title_block").removeClass("active");
        $(this).parent(".tab_title_block").addClass("active");
        $(".panel.entry-content.sp-tab.des_mb_2.des_style_").hide();
         $(dataTargetVal).addClass("active");
        $(dataTargetVal).show();
        
        
});

 });//document ready

       

          
/*
  $("body").on("click",".t4s-site-nav__search a.t4s-d-lg-none",function(){
    $('#t4s-search-hidden').attr("style","display:none");
    $('.t4s-mini-search__input').trigger("focus");    
    $('.t4s-mini-search__input').trigger("click");    
    handleCancelSearch = setInterval(getCancel, 100);
  });

  function getCancel(){
      if($('.cloud-search-mobile .cloud-search-mobile__cancel').length > 0){
         $("body").on("click",".cloud-search-mobile .cloud-search-mobile__cancel",function(){
          $('body').removeClass("is--opend-drawer");
          $('body').removeClass("t4s-lock-scroll");
          $('.t4s-drawer__close').trigger("click");    
          handleCancelSearch = setInterval(getCancel, 100);
          });        
          clearInterval(handleCancelSearch);
          }
    }
    */
     
  var handleCancelSearch = '';
document.querySelector('.t4s-site-nav__search .t4s-d-lg-none').addEventListener('click', function() {
   $('#t4s-search-hidden .t4s-mini-search__input').trigger("click");
  document.querySelector('#t4s-search-hidden .t4s-mini-search__input').click();
  
    document.querySelector('#t4s-search-hidden').style.display = 'none';
    
    handleCancelSearch = setInterval(getCancel, 100);
});

function getCancel() {
  if(document.querySelectorAll('.cloud-search-mobile .cloud-search-mobile__cancel').length > 0){
    var cancelButtons = document.querySelectorAll('.cloud-search-mobile .cloud-search-mobile__cancel');
    cancelButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            document.querySelector('.t4s-drawer__close').click();
            document.body.classList.remove('is--opend-drawer', 't4s-lock-scroll');
        });
    });
     var backdropButtons = document.querySelectorAll('.cloud-search-mobile-backdrop');
    backdropButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            document.querySelector('.t4s-drawer__close').click();
            document.body.classList.remove('is--opend-drawer', 't4s-lock-scroll');
        });
    });
    clearInterval(handleCancelSearch);
  }
}
  var popupCookiee = getCookie("popup-postal-jtpl")
  var newPostalCode =  $(".postal-code-form").find("input.postal-code-input").val();
  var url = window.location.href;
   if(popupCookiee == '' && url.indexOf("myshopify.com") == -1){
   
          var data = {
              attributes: {
                  popupPostalCode: '',
              }
          };
          $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
              contentType: 'application/json',
               async:false,
               type: 'POST',
              data: JSON.stringify(data),
              complete: function(xhr) {
                 setCookiePopup("popup-postal-jtpl", newPostalCode);
                  location.reload();
              setTimeout(function(){
               $(".coll-prices-jtpl span").attr("style","visibility:visible !important;");
                $(".coll-prices-jtpl").removeClass("animated-background");
            },500);
               
                  
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });
   }

});
if($("body").hasClass("template-product")){
   setTimeout(function(){
               $(".coll-prices-jtpl span").attr("style","visibility:visible !important;");
                $(".coll-prices-jtpl").removeClass("animated-background");
            },3000);
}
function removeCartAttributes(){
  fetch('/cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    attributes: {} // Clearing all cart attributes
  })
})
.then(response => response.json())
.then(data => console.log('Cart attributes cleared:', data))
.catch(error => console.error('Error clearing cart attributes:', error));

  
   var cities = getCookie("jtpl-cities");
    var region = getCookie("jtpl-region");
    var postalCodeCurrnt = getCookie("jtpl-postal");
         
          var data = {
              attributes: {
                  postalCity: cities,
                  postalRegion: region,
                  postalCode: postalCodeCurrnt,
                 
              }
          };
  
          $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
              contentType: 'application/json',
               async:false,
               type: 'POST',
              data: JSON.stringify(data),
              complete: function(xhr) {
                  location.reload();
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });
  }

function changePostalDetails(){
          var data = {
              attributes: {
                  postalCode: '',
                  region: '',
              }
          };
          $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
               async:false,
               contentType: 'application/json',
              type: 'POST',
              data: JSON.stringify(data),
              complete: function(xhr) {
                  location.reload();
              },
              error: function(xhr) {
                  console.log(xhr.responseText);
              },
          });
  }
    /**cookies */
function setCookie(cname,cvalue) {
  var d = new Date();
  var minutes = $(".location-menu").attr("cooki-jtpl");
  d.setTime(d.getTime() + (minutes * 60 * 1000));
  console.log(d.toUTCString());
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function setCookiePopup(cname,cvalue) {
  var d = new Date();
  var minutes = $(".location-menu").attr("cooki-popup-jtpl");
  d.setTime(d.getTime() + (minutes * 60 * 1000));
  console.log(d.toUTCString());
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}



/* Hide the Quick Shop button when product is classified as a preorder*/

function hidePreorderButtons(container = document) {
  container.querySelectorAll(".t4s-product").forEach(function (product) {
    const optionsData = product.getAttribute("data-product-options");

    try {
      const options = JSON.parse(optionsData);

      if (options.isPreoder === true) {
         const btns = product.querySelector(".t4s-product-btns");

        if (btns) {
          const oldBtn = btns.querySelector("a, button");

          if (oldBtn) {
            // Create fake button
            const fakeBtn = document.createElement("div");
            fakeBtn.className = "fake-preorder-btn";
            

            const locale = Shopify?.locale || 'en'; // fallback to 'en' if undefined
            fakeBtn.innerText = locale === 'fr' ? 'Précommander' : 'Pre-order';


            // Replace the real button with the fake one
            oldBtn.replaceWith(fakeBtn);
          }
        }

        // Observe .t4s-product-btns2 for when quickview is injected
        const btns2 = product.querySelector(".t4s-product-btns2");
        if (btns2) {
          const quickview = btns2.querySelector(".t4s-pr-quickview");
          if (quickview) {
            quickview.style.display = "none";
          } else {
            // Wait for quickview to be added
            const innerObserver = new MutationObserver((mutations, obs) => {
              const qv = btns2.querySelector(".t4s-pr-quickview");
              if (qv) {
                qv.style.display = "none";
                obs.disconnect(); // stop watching once handled
              }
            });

            innerObserver.observe(btns2, { childList: true, subtree: true });
          }
        }
      }
    } catch (e) {
      console.warn("Failed to parse data-product-options:", e);
    }
  });
}



document.addEventListener("DOMContentLoaded", function () {
  // Initial run
  hidePreorderButtons();

  // MutationObserver to catch dynamically added products
  let debounceTimeout;

const observer = new MutationObserver(function (mutations) {
  clearTimeout(debounceTimeout);

  debounceTimeout = setTimeout(() => {
    // Products were added recently, re-run
    hidePreorderButtons();
  }, 200); // Wait 200ms after last mutation before acting
});

const containerToWatch = document.querySelector(".t4s_box_pr_grid");

if (containerToWatch) {
  observer.observe(containerToWatch, {
    childList: true,
    subtree: true,
  });
} else {
  console.warn("Observer target '.t4s_box_pr_grid' not found!");
}


});

